import axios from 'axios';

const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '/api' : (process.env.REACT_APP_API_URL || 'http://localhost:5001/api')
});

// Search & Leads
export const searchLeads = (data) => api.post('/search', data);
export const getSearchHistory = () => api.get('/search/history');
export const getHistoryById = (id) => api.get(`/search/history/${id}`);
export const exportToExcel = (data) => api.post('/search/export', data, { responseType: 'blob' });

// Admin & API Key Management
export const verifyPasscode = (passcode) => api.post('/admin/verify', { passcode });
export const getApiKeys = () => api.get('/admin/keys');
export const updatePrimaryKey = (data) => api.post('/admin/keys/primary', data);
export const addApiKey = (data) => api.post('/admin/keys', data);
export const updateApiKey = (id, data) => api.put(`/admin/keys/${id}`, data);
export const setActiveKey = (id) => api.post(`/admin/keys/${id}/set-active`);
export const deleteApiKey = (id) => api.delete(`/admin/keys/${id}`);
export const resetApiKey = (id) => api.post(`/admin/keys/${id}/reset`);
